import { defineMessages } from "react-intl";

export const useAlertStatusTranslations = () => {
  return defineMessages({
    resolved: {
      defaultMessage: "Resolved",
      description:
        "Status label indicating an alert has been addressed and is no longer active",
    },
    ongoing: {
      defaultMessage: "Ongoing",
      description:
        "Status label indicating an alert is currently active and unresolved",
    },
  });
};
